//
//import ProviderDebtToPayService from '@/services/api/purchase/PchProviderDebtToPay'
import DetailProviderPaymentHeaders from '@/views/Purchase/PchDetailProviderPayment/PchDetailProviderPaymentHeaders'
import ProviderPaymentPosPaymentTypeHeaders from '@/views/Purchase/PchProviderPaymentPosPaymentType/PchProviderPaymentPosPaymentTypeHeaders'

//
export default [
	{
		name: 'pch_provider',
		type: 'item-field',
		flex: {
			xs12: true,
			sm6: true,
		},
		props: {
			itemAvatarText: 'business_name',
			itemTitle: 'business_name',
			itemSubTitle: 'rut',
			subheader: 'Proveedor',
		},
	},
	{
		name: 'hr_employee',
		type: 'item-field',
		flex: {
			xs12: true,
			sm6: true,
		},
		props: {
			itemAvatarText: 'name_case',
			itemTitle: 'name_case',
			itemSubTitle: 'rut',
			subheader: 'Responsable',
		},
	},
	{
		name: 'pch_detail_provider_payments',
		type: 'table-field',
		flex: {
			xs12: true,
		},
		props: {
			checkable: false,
			headers: DetailProviderPaymentHeaders,
			toolbarTitle: 'Listado de deudas incluidas en el pago',
		},
	},
	{
		name: 'pch_provider_payment_pos_payment_types',
		type: 'table-field',
		flex: {
			xs12: true,
		},
		props: {
			checkable: false,
			headers: ProviderPaymentPosPaymentTypeHeaders,
			toolbarTitle: 'Listado de medios de pago',
		},
	},
]